import { Alert, Flex, theme } from 'antd';
import { twMerge } from 'tailwind-merge';

type InfoMessageCardProps = {
  className?: string;
};

const InfoMessageCardEcho = ({ className }: InfoMessageCardProps) => {
  const { token } = theme.useToken();

  return (
    <Flex className={twMerge(className)}>
      <Alert
        data-testid="info-message"
        type="info"
        showIcon
        title="Daily earning estimates can take 1-2 days to reflect the latest impressions data."
        styles={{
          root: {
            background: token.colorBgContainer,
            borderColor: token.colorBorderSecondary,
            padding: token.paddingLG,
            width: '100%',
          }
        }}
      />
    </Flex>
  );
};

export default InfoMessageCardEcho;
